import HeroSection from '../components/sections/HeroSection'
import WhatIsFranchise from '../components/sections/WhatIsFranchise'
import WhyFranchise from '../components/sections/WhyFranchise'
import EarningsCalculator from '../components/sections/EarningsCalculator'
import JourneySteps from '../components/sections/JourneySteps'
import FaqSection from '../components/sections/FaqSection'
import BreadcrumbSection from '../components/sections/BreadcrumbSection'

export default function HomePage() {
  return (
    <main className="min-h-screen bg-white font-sans">
      <HeroSection />
      
      <section className="bg-white py-20">
        <div className="container mx-auto px-4">
          <WhatIsFranchise />
        </div>
      </section>
      
      <WhyFranchise />
      
      <EarningsCalculator />
      
      <JourneySteps />
      
      <FaqSection />
      
      <BreadcrumbSection />
    </main>
  )
}
